import React from 'react';
import PropTypes from 'prop-types';

const Urine = ({ searchTerm, isDarkMode }) => {
  const urineValues = {
    general: [
      {
        test: 'Calcium',
        conventional: '100–300 mg/24 h',
        si: '2.5–7.5 mmol/24 h'
      },
      {
        test: 'Osmolality',
        conventional: '50–1200 mOsmol/kg H₂O',
        si: '50–1200 mOsmol/kg H₂O'
      },
      {
        test: 'Oxalate',
        conventional: '8–40 μg/mL',
        si: '90–445 μmol/L'
      },
      {
        test: 'Proteins, Total',
        conventional: '<150 mg/24 h',
        si: '<0.15 g/24 h'
      }
    ]
  };

  const filterData = (data, term) => {
    if (!term) return data;
    const lowerTerm = term.toLowerCase();
    
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = data[key].filter(item => 
        item.test.toLowerCase().includes(lowerTerm) ||
        (typeof item.conventional === 'string' && 
         item.conventional.toLowerCase().includes(lowerTerm)) ||
        (typeof item.si === 'string' && 
         item.si.toLowerCase().includes(lowerTerm))
      );
      return acc;
    }, {});
  };

  const filteredValues = filterData(urineValues, searchTerm);

  return (
    <div className={isDarkMode ? 'ext_lbs_dark-mode' : ''}>
      {filteredValues.general.length > 0 && (
        <>
          <h2>Urine Parameters</h2>
          <div className="ext_lbs_labs-table_container">
            <table className="ext_lbs_labs-table">
              <thead>
                <tr>
                  <th>Test</th>
                  <th>Conventional Range</th>
                  <th>SI Range</th>
                </tr>
              </thead>
              <tbody>
                {filteredValues.general.map((item, index) => (
                  <tr key={index}>
                    <td>{item.test}</td>
                    <td>{item.conventional}</td>
                    <td>{item.si}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

Urine.propTypes = {
  searchTerm: PropTypes.string,
  isDarkMode: PropTypes.bool
};

export default Urine; 